export default __webpack_public_path__ + "static/media/willofthesublime.2d5617a2.png";